import React, { Component } from 'react'

import Searchbar from '../../utils/Searchbar'
import SearchOrder from '../../search/SearchOrder'

class OrderSearch extends Component {
    render() {
        return (
            <div>
                <Searchbar placeholder={"Search orders"} component={SearchOrder} searchEndpoint={'search/orders'} {...this.props} userType="admin" />
            </div>
        )
    }
}

export default OrderSearch



// WEBPACK FOOTER //
// ./src/components/admin/orders/OrderSearch.js